import React, { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom-v5-compat";
import { useTranslation } from "react-i18next";
import sadSoguiFaceBlack from "assets/images/sadSoguiFaceBlack.png";
import useInnerHeight from "Helpers/useInnerHeight";

import { BrandContext } from "./BrandContext";
import { VenueContext } from "./VenueContext";
import ErrorBoundary from "./ErrorBoundary";
import venueBrandForContext from "./venueBrand";
import Venue from "./Venue";
import Tabs, { Tab } from "./CustomerTab";
import { TabPaymentStatus } from "./TabPaymentStatus";
import Error from "./Error";

const App = ({ venue }) => {
  const { t } = useTranslation();
  const innerHeight = useInnerHeight();

  const venueBrand = venueBrandForContext(venue.venueBrand);
  useEffect(() => {
    document.body.classList.add("basicMenu");
  });

  return (
    <BrandContext.Provider value={venueBrand}>
      <VenueContext.Provider value={venue}>
        <ErrorBoundary
          errorPage={
            <Error
              errorMessage={
                <div className="flex flex-col space-y-32 justify-center items-center max-w-sm">
                  <img
                    src={sadSoguiFaceBlack}
                    alt="SoguiSadLogoBlack"
                    className="w-full"
                  />
                  <h3 className="text-xl">{t("errors.general")}</h3>
                </div>
              }
            />
          }
        >
          <div
            id="scrollLock"
            className={`max-h-screen h-screen overflow-y-hidden`}
            style={{
              background: `linear-gradient(${venueBrand.brandColor}, #ffffff)`,
            }}
          >
            <div
              id="OnsiteSiteScrollContainer"
              className="overflow-y-auto overflow-x-hidden bg-white mx-auto sm:shadow sm:max-w-sm max-w-screen-sm md:max-w-xl h-screen"
              style={{
                minHeight: innerHeight - 104,
                height: innerHeight,
              }}
            >
              <Routes>
                <Route path="tabs" element={<Tabs />}>
                  <Route path=":customerTabUuid">
                    <Route index element={<Tab />} />
                    <Route path="payments">
                      <Route path=":status" element={<TabPaymentStatus />} />
                    </Route>
                  </Route>
                  <Route
                    path="*"
                    element={
                      <div>
                        <Error
                          errorMessage={
                            <div className="flex flex-col space-y-32 justify-center items-center">
                              <img
                                src={sadSoguiFaceBlack}
                                alt="SoguiSadLogoBlack"
                                className="w-full"
                              />
                              <h3 className="text-xl">
                                {t("errors.pageNotFound")}
                              </h3>
                            </div>
                          }
                        />
                      </div>
                    }
                  />
                </Route>

                <Route path="*" element={<Venue />} />
              </Routes>
            </div>
          </div>
        </ErrorBoundary>
      </VenueContext.Provider>
    </BrandContext.Provider>
  );
};

export default App;
